import React from "react";
import { lightThemeColors } from "../../assets/style/colors";
import styled from "styled-components";

import { ReactComponent as GridDecoration } from "../../assets/decorations/blueBannerGridDataAnalytics.svg";
import ResultsCard from "../generic/ResultsCard";

const IncreaseEngagementBanner = () => {
  const cards = [
    {
      title: "3x increase",
      description: "in overall user\n   engagement",
      titleStyle: {
        color: "rgba(39, 16, 60, 1)",
      },
    },
    {
      title: "70% increase",
      description: "in daily \n active users",
      titleStyle: {
        color: "rgba(39, 16, 60, 1)",
      },
    },
    {
      title: "65% improvement",
      description: "in user\n retention",
      titleStyle: {
        color: "rgba(39, 16, 60, 1)",
      },
    },
    {
      title: "+60%",
      description: `in referral\n conversions`,
      titleStyle: {
        color: "rgba(39, 16, 60, 1)",
      },
    },
  ];
  return (
    <FullPageContainer>
      <DecorationWrapper>
        <GridDecoration />
      </DecorationWrapper>
      <Container>
        <Title>Proven Results for User Engagement</Title>
        <Content>
          {cards.map((item, index) => (
            <ResultsCard
              key={index}
              titleStyle={item.titleStyle}
              title={item.title}
              description={item.description}
            />
          ))}
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default IncreaseEngagementBanner;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.analyseBg};
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 100px 80px;
  gap: 50px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 50px;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  z-index: 2;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;
const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  @media (max-width: 990px) {
    font-size: 24px;
    line-height: 36px;
    text-align: center;
  }
`;
const DecorationWrapper = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  svg {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 990px) {
    svg {
      height: 100%;
      width: unset;
    }
  }
`;
